import { object, string, number, mixed, array } from "yup"

export default object({
  id: number().positive(),
  name: string()
    .min(2, "Variety Name should be atleast 2 char long")
    .required("Variety Name is required!")
    .label("Variety Name"),
  preferredSku: mixed().label("Preffered SKU"),
  preferredCertification: mixed().label("Preffered Certification"),
  standardDeduction: number()
    .positive()
    .min(0)
    .max(100)
    .nullable()
    .label("Standard Deduction"),
  estimatedProduce: number()
    .min(0)
    .nullable(true)
    .required()
    .label("Estimated Produce"),
  commodity: mixed().required().label("Commodity"),
  primaryGroup: mixed().label("Primary Group"),
  groups: array().label("Variety Groups"),
  qualityParameters: array().label("Quality Parameters"),
  harvestGrades: array()
    .min(1, "Please enter atleast 1 harvest grade")
    .label("Harvest Grades"),
})
